import { render, staticRenderFns } from "./ClientsSidebar.vue?vue&type=template&id=8feba0f4&"
import script from "./ClientsSidebar.vue?vue&type=script&lang=js&"
export * from "./ClientsSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports